module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "allowfullscreen": ""
    }
  }, [_c('div', {
    staticClass: "prism-player",
    staticStyle: {
      "height": "195px"
    },
    attrs: {
      "id": _vm.playid
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.btn()
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c7c9ad54"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/aliplay/index.vue
// module id = 293
// module chunks = 107